import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Header from './Header'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { CustomInput } from './Component'
import useStore from './store'
import Button from '@material-ui/core/Button';
import { doPost } from './AjaxRequests'
import Swal from 'sweetalert2'
import { useHistory , Link } from "react-router-dom";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link as LinkIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.paper.white,
    },
    info: {
        paddingBottom: theme.spacing(2),
        color: theme.palette.text.white,
        fontSize: "18px",
    },
    subTitle: {
        color: theme.palette.text.white,
        fontSize: "18px",        
    },
    btn__wrapper: {
        width: "100%",       
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        padding: theme.spacing(3, 0)
    }
}));

export default function ApplyHistory() {

    const classes = useStyles()
    const store = useStore()
    const [historyData, setHistoryData] = useState([])
    const history = useHistory();

    useEffect(() => {
        const payload = {
            "api": "GetDoorAccess4Applyer",
            "apply_user_idno": store.login.idno,
            "apply_user_phone": store.login.phone
        }

        doPost('https://www.kfsyscc.org/normal_api/service', payload)
            .then((data) => {
                if (data.status && data.data.length > 0) {
                    setHistoryData(data.data)
                } else {
                    Swal.fire("查無申請紀錄", "", "info")
                    // history.push('/page1')
                }
         
            })


    }, [])


    return <Grid container spacing={3}>
        <Grid item xs={12}>
            <Header />
        </Grid>
        <Grid item xs={12}> 
            <div className={classes.btn__wrapper}>                
                <Link to="/" style={{textDecoration:"none", margin:"0 20px"}}>
                    <Button variant="contained" color="primary">
                        回首頁
                    </Button> 
                </Link>
                {/* <Link to="/page1" style={{textDecoration:"none", margin:"0 20px"}}>
                    <Button variant="contained" color="secondary">
                        新申請
                    </Button> 
                </Link> */}
            </div>                                                 
        </Grid>       
        <Grid item xs={12}>
            <Typography               
                className={classes.info}
            >
                申請人身份證字號:{store.login.idno}
            </Typography>
            <Typography                
                className={classes.info}
            >
                申請人手機:{store.login.phone}
            </Typography>
            <Typography
                variant="h6"
                className={classes.subTitle}
            >
                申請紀錄
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">姓名</TableCell>
                            <TableCell align="center">通關日期</TableCell>
                            {/* <TableCell align="right">開始</TableCell>
                            <TableCell align="right">結束</TableCell> */}
                            <TableCell align="center">我的通行證</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {historyData.map((row) => (
                            <TableRow key={row.access_key}>
                                <TableCell align="center" component="th" scope="row">
                                    {row.apply_user_name}
                                </TableCell>
                                <TableCell align="center">{row.reg_date}</TableCell>
                                {/* <TableCell align="right">{row.start_datetime}</TableCell>
                                <TableCell align="right">{row.close_datetime}</TableCell> */}
                                <TableCell align="center">
                                    <Link to={`/result?access_key=${row.access_key}&result_type=query`}>
                                        <LinkIcon/>
                                    </Link>                                    
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
        
    </Grid>
}

